import { CollectionProduct } from 'models/collection/collection';
import { Gtm } from 'tracking';
import { useEffect } from 'react';

interface Input {
  shouldTrigger?: boolean;
  products?: CollectionProduct[];
  collectionTitle: string;
}

/**
 * Tracking hook for collections in cdp, search results and fube
 */
const useCollectionReady = ({ shouldTrigger = true, products, collectionTitle }: Input): void => {
  useEffect(() => {
    if (!shouldTrigger || !products || products.length === 0) {
      return;
    }

    const convertedProducts = products
      // Criteo tag only needs first three products
      .slice(0, 3)
      .map((x, idx) => ({
        productId: x.id,
        productType: x.productType,
        productTitle: x.title,
        tags: x.tags.join(','),
        list: collectionTitle || '',
        position: idx,
        variantId: x.variants[0].id,
      }));

    Gtm.track({
      group: Gtm.Group.Collection,
      name: Gtm.CommonEvent.Ready,
      nonInteractive: true,
      data: {
        products: convertedProducts,
      },
    });
  }, [collectionTitle, products, shouldTrigger]);
};

export default useCollectionReady;
